import type { JourneyDefinition, PlanStep } from "../plan.types";
import { IUI_PARTNER } from "./iui-partner";
import { SPERM_DONATION } from "./sperm-donation";

function removePartnerTrack(step: PlanStep): PlanStep {
  // A partner relationship and a sperm source are independent. These paths
  // must not manufacture a partner task when the accepted plan says solo or
  // donor, and the server remains the authority for any shared record.
  return { ...step, partnerTrack: undefined };
}

export const IUI_SOLO: JourneyDefinition = {
  ...IUI_PARTNER,
  key: "iui-solo",
  pathway: "solo",
  steps: IUI_PARTNER.steps.map(removePartnerTrack),
};

export const IUI_DONOR: JourneyDefinition = {
  ...IUI_PARTNER,
  key: "iui-with-donor",
  pathway: "with-donor",
  description: "Intrauterine insemination with donor sperm",
  steps: IUI_PARTNER.steps.map(removePartnerTrack),
};

export const IUI_DONOR_MALE: JourneyDefinition = {
  ...SPERM_DONATION,
  key: "iui-with-donor-male",
  goal: "pregnancy",
  pathway: "with-donor",
  title: "Sperm Donation",
  description: "Provide a screened sperm source for an IUI cycle",
};
